<template>
	<div id="voiceSceneTeacher">
    <!--=========================左边部分，显示脚本=========================-->
    <div class="left" v-if="scriptTitle">
    <!--<div class="left">-->
			<div class="header">营销场景:{{scriptTitle}}</div>
			<div class="content">
				<div class="kong">
                    <div style="font-size: 16px;margin:20px 0px 0px 10px;background-color: #F2F2F2;min-height:170px;padding:10px 20px 10px 20px;">
                        <div><b>项目介绍</b></div>
						<div>{{scriptObj.intro}}</div>
                    </div>
					<div style="font-size: 16px;margin:10px 0px 0px 10px;background-color: #F2F2F2;min-height:170px;padding:10px 20px 10px 20px;">
						<div><b>参考话术</b></div>
						<div style="font-size: 14px;" v-html="scriptObj.script"></div>
					</div>
				</div>
			</div>
		</div>
    <!--=========================中间部分，打分考核通过/不通过=========================-->
    <div class="left">
  		<div class="header kaohe">
            <!--scriptTitle是淘金大学的‘话术场景名称’，而name是语音岗前的‘场景名称’-->
  			<span>考核点评{{scriptTitle?'（' + scriptTitle + '）' : '（' + name + '）'}}</span>
  			<template v-if="passedStatus != null">
  				<div v-if="passedStatus" class="pass">
	  				<span>考核通过</span>
	  			</div>
	  			<div v-else class="nopass">
	  				<span>考核不通过</span>
	  				<template v-if="showBtn">
	  					<a class="btn" @click="updateExamStatus(1)">继续考核</a>
	  					<a class="btn red" @click="updateExamStatus(0)">结束考核</a>
	  				</template>
	  			</div>
  			</template>
  		</div>
  		<div class="content">
				<p>考核状态</p>
				<div class="box">
					<p><el-radio v-model="effectStatus" :label="1">有效</el-radio></p>
					<p><el-radio v-model="effectStatus" :label="0">无效</el-radio></p>
					<template v-if="effectStatus == 0">
						<p><el-input v-model="effectReason" placeholder="输入无效原因，显示在考核得分" clearable></el-input></p>
						<p>例如：通话中挂断，本次考核无评分与建议</p>
					</template>
				</div>
				<p class="totalScore" v-if="effectStatus == 1">
					<span>考核点评</span>
				</p>
				<div class="box" v-if="effectStatus == 1">
					<template v-for="(f, index) in gradeList">
						<p class="name">{{ f.name }}</p>
						<template v-for="(s, key) in f.childList">
							<p class="second name"><span>*</span>{{ s.name }}</p>
							<p class="second" v-for="(t, tkey) in s.childList">
								<el-radio v-model="s.checked" :label="t.id" @change="computeTotalScore">{{ t.name }}</el-radio>
							</p>
						</template>
					</template>
				</div>
				<p class="advice" v-if="effectStatus == 1">
					<span>考核建议</span>
					<span class="btn-advice" @click="addEvaluate">添加建议</span>
				</p>
				<div class="box" v-if="effectStatus == 1">
					<div class="row" v-for="(e, key) in evaluateList">
						<el-input v-model="e.evaluate" placeholder="输入建议" clearable></el-input>
						<span @click="delEvaluate(key)">删除</span>
					</div>
				</div>
  		</div>
  		<div class="save">
  			<span class="score">总分：{{ gradeScore ? gradeScore : totalScore }}分</span>
  			<a @click="saveScore">保存</a>
  		</div>
  	</div>
  	<div class="right">
  		<div class="header">客服考核记录</div>
  		<div class="content">
  			<div class="kong" v-if="list.length == 0">
					<img src="@/assets/images/voiceScene/icon_kong_list.png" />
					<p>该客服没有考核记录</p>
				</div>
				<template v-else>
					<!-- <div class="list" v-if="check!=''">
						<span class="type" >抽查</span>
						<span class="time">{{this.check}}</span>
					</div> -->
					<div class="list" v-for="(l, index) in list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
						<div :class="{'top': true, 'hasborder': l.effectStatus == 1}">
							<span class="type" v-if="l.recordType == 'Each'">对练</span>
							<span class="type" v-if="l.recordType == 'Teacher'">陪练</span>
							<span class="type" v-if="l.recordType == 'Exam'">考核</span>
							<span class="time">{{ l.beginTime }}</span>
							<span :class="{'score': true, 'wuxiao': l.effectStatus == 0}">
								{{ l.effectStatus == 0 ? '无效' : l.effectStatus == 1 ? l.gradeScore : '待评分' }}
							</span>
							<a target="_blank" :href="'/tjkStudy/newKaoheTeacherDetail?id='+l.id"><span class="el-icon-arrow-right"></span></a>
						</div>
						<ul class="clear" v-if="l.effectStatus == 1">
							<li v-for="(g, key) in l.gradeList">{{ g.name }}：{{ g.gradeScore }}</li>
						</ul>
					</div>
					<p v-if="loading" class="nomore">加载中...</p>
        	<p v-if="noMore" class="nomore">没有更多了</p>
				</template>
  		</div>
  	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				callId: '',
				imageUrl: '', //场景封面
				name: '', //场景名称
				gradeList: [],
				showBtn: null, //是否显示继续考核/结束考核
				passedStatus: null, //考核是否通过
				effectStatus: null, //是否有效
				effectReason: '', //无效原因
				evaluateList: [], //练习建议
				gradeScore: '', //保存打分后接口返回分数
				list: [],
				count: 0,
				total: 0,
				pages: 0,
				pageNum: 1,
				pageSize: 20,
				loading: false,
				totalScore: 0, //评分总分
				check:'',//抽查内容
                scriptTitle:null,//话术标题
                scriptObj:{
                    intro:null,
                    script:null
				}
			}
		},
		computed: {
	    noMore: {
	      get: function() {
	        return this.count >= this.pages - 1;
	      },
	      set: function() {

	      }
	    },
	    disabled: {
	      get: function() {
	        return this.loading || this.noMore;
	      },
	      set: function() {

	      }
	    }
	  },
		created() {
			window.getCallId = this.getCallId;
		},
		methods: {
			//接收callId
			getCallId(id) {
				console.log('传进来的callId-----'+id)
				this.callId = id;
				// this.queryTjkScriptByCallId();//淘金大学没使用了,弃用
				this.queryList(true);
				this.queryScene();
				this.queryGrade();
			},
			//查询场景名称
			queryScene() {
				this.$http.post(API_ROOT.college + '/voiceExerciseTeacher/queryExamCustomerScene', {'callId': this.callId}).then(response=>{
					var result = response.data;
					if(result.success) {
						this.imageUrl = result.data != null ? result.data.imageUrl : '';
						this.name = result.data != null ? result.data.name : '';
					}else{
						this.$alert('查询场景错误：'+result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			load() {
	      this.loading = true;
	      setTimeout(() => {
	        this.count += 1;
	        this.queryList(false);
	      }, 100);
	    },
			//查询练习记录
			queryList(init) {
				if(init) {
					this.pageNum = 1;
					this.list = [];
				}
				let data = {
					'callId': this.callId,
					'pageNum': this.pageNum,
					'pageSize': this.pageSize
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryRecord', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.total = result.data.total;
						this.pages = result.data.pages;
						if(result.data.list != null) {
							for(let i=0,len=result.data.list.length;i<len;i++) {
								this.list.push(result.data.list[i]);
							}
						  this.pageNum++;
						}
					}else{
						this.$alert('查询练习记录错误：'+result.msg);
					}
					this.loading = false;
				},response => {
					this.loading = false;
					this.$alert('AJAX访问接口异常！');
				})
			},
			//查询评分字段
			queryGrade() {
				let data = {
					'callId': this.callId
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseTeacher/queryExamGradeField', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.id = result.data.id;
						this.showBtn = result.data.showBtn;
						this.passedStatus = result.data.passedStatus;
						this.effectStatus = result.data.effectStatus;
						this.effectReason = result.data.effectReason;
						this.gradeScore = result.data.gradeScore;
						this.evaluateList = [];
						if(result.data.evaluateList) {
							result.data.evaluateList.map((item) => {
								this.evaluateList.push({'evaluate': item});
							})
						}else {
							this.evaluateList.push({'evaluate': ''});
						}
						this.gradeList = result.data.gradeList;
						this.gradeList.map((item) => {
							item.childList.map((obj) => {
								for(let i=0;i<obj.childList.length;i++) {
									if(obj.childList[i].checked) {
										this.$set(obj, 'checked', obj.childList[i].id);
										break;
									}else {
										this.$set(obj, 'checked', '');
									}
								}
							})
						})
					}else{
						this.$alert('查询评分错误：'+result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
            /*queryTjkScriptByCallId() {
				this.$http.post(API_ROOT.college + '/tjCollegeTrain/queryTjkScriptByCallId', {"callId": this.callId}).then(response=>{
					var result = response.data;
					if(result.success) {
                        this.scriptTitle = result.data == null ? null : result.data.title;
                        this.scriptObj = result.data == null ? {} : result.data;
                        console.log('===queryTjkScriptByCallId.callId='+this.callId+'_____'+this.scriptObj)
                    }else{
						this.$alert("对练脚本 error:"+result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},*/
			addEvaluate() {
				this.evaluateList.push({'evaluate': ''});
			},
			delEvaluate(key) {
				this.evaluateList.splice(key, 1);
			},
			//计算总分
			computeTotalScore() {
				this.totalScore = 0;
				for(let i=0;i<this.gradeList.length;i++) {
					for(let j=0;j<this.gradeList[i].childList.length;j++) {
						if(this.gradeList[i].childList[j].checked != null) {
							for(let c=0;c<this.gradeList[i].childList[j].childList.length;c++) {
								if(this.gradeList[i].childList[j].checked == this.gradeList[i].childList[j].childList[c].id) {
									this.$set(this, 'totalScore', this.totalScore + this.gradeList[i].childList[j].childList[c].score);
									break;
								}
							}
						}
					}
				}
			},
			//提交评分
			saveScore() {
				if(this.effectStatus != 0 && this.effectStatus != 1) {
					this.$alert('请选择考核状态');
					return false;
				}
				if(this.effectStatus == 0 && this.effectReason == '') {
					this.$alert('请填写无效原因');
					return false;
				}

				let choiceRuleIds = [],
						evaluateList = [];

				if(this.effectStatus == 1) {
					for(let i=0;i<this.gradeList.length;i++) {
						for(let j=0;j<this.gradeList[i].childList.length;j++) {
							if(!this.gradeList[i].childList[j].checked) {
								this.$alert('考核点评为必选');
								return false;
								break;
							}else {
								choiceRuleIds.push(this.gradeList[i].childList[j].checked);
							}
						}
					}
					for(let i=0;i<this.evaluateList.length;i++) {
						if(!this.evaluateList[i].evaluate) {
							this.$alert('请填写考核建议');
							return false;
							break;
						}else {
							evaluateList.push(this.evaluateList[i].evaluate);
						}
					}
				}

				let data = {
					'id': this.id,
					'callId': this.callId,
					'effectStatus': this.effectStatus,
					'effectReason': this.effectReason,
					'choiceRuleIds': choiceRuleIds,
					'evaluateList': evaluateList
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseTeacher/saveExamGrade', data).then(response=>{
					var result = response.data;
					if(result.success) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.queryList(true);
						this.queryGrade();
					}else{
						this.$alert('提交评分错误：'+result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//继续考核/结束考核
			updateExamStatus(status) {
				let text = status == 0 ? '是否确定结束考核？' : '是否确定继续考核？';
				this.$confirm(text, '提示', {
	        confirmButtonText: '确定',
	        cancelButtonText: '取消',
	        type: 'warning'
	      }).then(() => {
	      	let data = {
						'callId': this.callId,
						'status': status
					}
					this.$http.post(API_ROOT.college + '/voiceExerciseTeacher/updateExamStatus', data).then(response=>{
						var result = response.data;
						if(result.success) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.queryGrade();
						}else{
							this.$alert('错误：'+result.msg);
						}
					},response => {
						this.$alert('AJAX访问接口异常！');
					})
	      }).catch(() => {})

		 }
		}
	}
</script>


// WEBPACK FOOTER //
// ./src/page/newVoiceScene/kaoheTeacher.vue